import React from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { THEME_COLORS } from '../../common/colors';

const LineItem = styled.div`
  width: 100%;
  padding: 16px 8px;
  margin-bottom: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ showBorder }) => showBorder && 'border-bottom: 1px #F4F5F4 solid;'}
`;
const AssetContent = styled.div`
  display: flex;
  width: 100%;
`;

const AssetDetails = styled.div`
  position: relative;
  width: 75%;
`;

const AssetThumbnail = styled.div`
  width: ${({ isMobile }) => (isMobile ? 55 : 100)}px;
  height: ${({ isMobile }) => (isMobile ? 55 : 100)}px;
  margin-right: 12px;
  border-radius: 12px;
  overflow: hidden;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const AssetTitle = styled(Typography)`
  font-weight: 500 !important;
  font-size: 1.2rem !important;
  display: block !important;
`;

const AssetDescription = styled(Typography)`
  font-size: 1rem !important;
  display: block !important;
  margin-bottom: 16px !important;
  word-wrap: break-word;
`;

function TruncateTitle({ title, length }) {
  if (title.length > length) {
    return <span>{title.slice(0, length)}...</span>;
  }

  return <span>{title}</span>;
}

const LearnMoreButton = styled(Button)`
  background-color: ${THEME_COLORS.primary} !important;
  box-shadow: unset !important;
  border-radius: ${({ isMobile }) => (isMobile ? 4 : 12)}px !important;
  font-weight: 800 !important;
  font-size: 0.83rem;
  padding: ${({ isMobile }) => (isMobile ? 8 : 2)}px 10px !important;
  text-transform: capitalize !important;
  width: ${({ isMobile }) => (isMobile ? '60%' : '85px')} !important;
  ${({ isMobile }) =>
    !isMobile &&
    `
    position: absolute !important;
    bottom: 4px !important;
    right: 24px !important;`};
`;

export function AssetLineItem({ asset, isMobile, showBorder }) {
  const history = useHistory();
  return (
    <LineItem showBorder={showBorder}>
      <AssetContent>
        <AssetThumbnail isMobile={isMobile}>
          <img
            alt={asset.title}
            src={asset.mainImage}
            onClick={() => window.open(`/assets/${asset.uuid}`, '_blank')}
            style={{ cursor: 'pointer' }}
          />
        </AssetThumbnail>
        <AssetDetails>
          <AssetTitle
            onClick={() => history.push(`/assets/${asset.uuid}`)}
            style={{ cursor: 'pointer' }}
          >
            <TruncateTitle length={isMobile ? 42 : 52} title={asset.title} />
          </AssetTitle>
          <AssetDescription>
            <TruncateTitle
              length={isMobile ? 100 : 130}
              title={asset.description}
            />
          </AssetDescription>
        </AssetDetails>
      </AssetContent>
      <LearnMoreButton
        type="submit"
        variant="contained"
        color="primary"
        size="small"
        onClick={() => window.open(`/assets/${asset.uuid}`, '_blank')}
        isMobile={isMobile}
      >
        Learn more
      </LearnMoreButton>
    </LineItem>
  );
}
